<template>
  <div class="text-center">
    <v-dialog
        v-model="visible"
        scrollable
        width="500">
      <v-card>
        <dialog-header :title="$t('partOrder.sendEmailAction')"
                       :close="close"/>
        <v-card-text>
          <part-order-properties-view :part-order="partOrder"/>


          <v-alert v-if="errorText"
                   elevation="3"
                   type="error">{{ errorText }}
          </v-alert>
          <v-alert v-if="!replyToEmail"
                   elevation="3"
                   type="error">{{ $t('partOrder.userEmailNotSet') }}
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="close" :disabled="sending">
            {{ $t('actions.cancel') }}
          </v-btn>
          <v-btn tile color="primary" dark @click="send"
                 :loading="sending"
                  :disabled="!replyToEmail">
            {{ $t('partOrder.send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PartOrderPropertiesView from '@/views/partorder/PartOrderPropertiesView';
import PartOrdersService from '@/services/PartOrdersService';
import DialogHeader from '@/components/layouts/DialogHeader';

export default {
  name: 'PartOrderMailSendingDialog',
  components: { DialogHeader, PartOrderPropertiesView },
  data: () => {
    return {
      visible: false,
      sending: false,
      partOrder: null,
      errorText: null,
    };
  },
  computed: {
    replyToEmail() {
      return this.$store.getters['userSessionStateStore/user']?.email;
    },
  },
  methods: {
    send() {
      this.sending = true;
      this.errorText = null;
      PartOrdersService.sendEmail(this.partOrder.id)
          .then(() => {
            this.close();
            this.$emit('done');
          })
          .catch(err => {
            console.log(JSON.stringify(err));
            let type = err?.response?.data?.type;
            if (type === 'field_error') {
              this.errorText = this.$t('partOrder.sendFieldError');
            } else if (type === 'not_configured') {
              this.errorText = this.$t('partOrder.sendNotConfiguredError');
            } else if (type === 'send_failed' || type == null) {
              this.errorText = this.$t('partOrder.sendFailedError');
            }

          })
          .finally(() => {
            this.sending = false;
          });
    },

    open(partOrderId) {
      PartOrdersService.get(partOrderId)
          .then((result) => {
            this.partOrder = result.data.partOrder;
            this.visible = true;
          })
          .catch(err => {
            console.log(JSON.stringify(err));
          });
    },



    close() {
      this.visible = false;
      this.partOrder = null;
      this.errorText = null;
      this.sending = false;
    },
  },
};
</script>

<style scoped>

</style>
